import environment from '#/environment/environment';
import {Chain, mainnet} from 'viem/chains';
import {webSocket} from 'wagmi';

export const getWebSocketTransport = (chain: Chain) => {
  if (environment.alchemyWssUrl && chain.id !== mainnet.id) {
    return webSocket(environment.alchemyWssUrl);
  }

  if (chain.rpcUrls.default.webSocket?.[0]) {
    return webSocket(chain.rpcUrls.default.webSocket[0]);
  }

  return null;
};
